import React from 'react'

const RightIcon = ({width =8, height=12, fill="#CE181E"}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 8 12" fill={fill} xmlns="http://www.w3.org/2000/svg">
<path d="M0.589844 10.59L5.16984 6L0.589844 1.41L1.99984 0L7.99984 6L1.99984 12L0.589844 10.59Z" fill={fill}/>
</svg>

  )
}

export default RightIcon